import { isRouteErrorResponse, useRouteError } from 'react-router';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { NotFoundPage } from './NotFoundPage.js';

export function RootErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;

  const detail =
    error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? `${error.status} ${error.statusText}`
        : 'No further detail was reported.';

  return (
    <Stack
      spacing={2}
      sx={{ minHeight: '100dvh', justifyContent: 'center', alignItems: 'center', px: 3, textAlign: 'center' }}
    >
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        The dashboard stopped unexpectedly
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '46ch' }}>
        Nothing was changed. Reloading gets you back — if it keeps happening, the detail below is
        what to send.
      </Typography>

      <Button
        variant="contained"
        onClick={() => {
          window.location.assign('/');
        }}
      >
        Reload
      </Button>

      {/* Shown rather than swallowed: the owner is the only bug-report channel there is. */}
      <Typography
        component="pre"
        variant="caption"
        sx={{
          mt: 2,
          p: 2,
          maxWidth: 560,
          overflowX: 'auto',
          textAlign: 'left',
          borderRadius: 1,
          bgcolor: 'var(--pos-surface-sunken)',
          color: 'text.secondary',
        }}
      >
        {detail}
      </Typography>
    </Stack>
  );
}
